// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisitSections-module__font-s-10___Ofuik {
  font-size: 10px !important;
}

.VisitSections-module__font-s-12___MhnRP {
  font-size: 12px !important;
}

.VisitSections-module__font-s-13___sECge {
  font-size: 13px !important;
}

.VisitSections-module__font-s-14___F1GeS {
  font-size: 14px !important;
}

.VisitSections-module__font-s-15___bZ0Mr {
  font-size: 15px !important;
}

.VisitSections-module__font-s-16___zLvT3 {
  font-size: 16px !important;
}

.VisitSections-module__font-s-18___tXxVk {
  font-size: 18px !important;
}

.VisitSections-module__font-s-20___t3MH9 {
  font-size: 20px !important;
}

.VisitSections-module__font-s-22___H6R9O {
  font-size: 22px !important;
}

.VisitSections-module__font-s-28___amOfC {
  font-size: 28px !important;
}

.VisitSections-module__font-w-400___BPfgV {
  font-weight: 400 !important;
}

.VisitSections-module__font-w-500___AbNt6 {
  font-weight: 500 !important;
}

.VisitSections-module__font-w-600___pV0wu {
  font-weight: 600 !important;
}

.VisitSections-module__font-w-700___bEv_W {
  font-weight: 700 !important;
}

.VisitSections-module__p-5___aLTR7 {
  padding: 5px !important;
}

.VisitSections-module__p-12___pwgjq {
  padding: 12px !important;
}

.VisitSections-module__p-16___Gh9Eg {
  padding: 16px !important;
}

.VisitSections-module__p-30___Mmkrr {
  padding: 30px !important;
}

.VisitSections-module__p-b-0___XO5_G {
  padding-bottom: 0 !important;
}

.VisitSections-module__p-b-5___AbwPu {
  padding-bottom: 5px !important;
}

.VisitSections-module__p-b-10___poEyW {
  padding-bottom: 10px !important;
}

.VisitSections-module__p-b-12___bx6P_ {
  padding-bottom: 12px !important;
}

.VisitSections-module__p-b-16___CzPrB {
  padding-bottom: 16px !important;
}

.VisitSections-module__p-b-18___W8ufW {
  padding-bottom: 18px !important;
}

.VisitSections-module__p-b-20___WYjdJ {
  padding-bottom: 20px !important;
}

.VisitSections-module__p-b-25___kBrIu {
  padding-bottom: 25px !important;
}

.VisitSections-module__p-b-30___vm5E7 {
  padding-bottom: 30px !important;
}

.VisitSections-module__p-b-50___P1PlP {
  padding-bottom: 50px !important;
}

.VisitSections-module__p-t-0___ZBW1e {
  padding-top: 0 !important;
}

.VisitSections-module__p-t-12___rauqN {
  padding-top: 12px !important;
}

.VisitSections-module__p-t-16___gLLa2 {
  padding-top: 16px !important;
}

.VisitSections-module__p-t-18___fQpHS {
  padding-top: 18px !important;
}

.VisitSections-module__p-t-20___ifiMw {
  padding-top: 20px !important;
}

.VisitSections-module__p-t-30___AU4N8 {
  padding-top: 30px !important;
}

.VisitSections-module__p-t-40___fbo7J {
  padding-top: 40px !important;
}

.VisitSections-module__p-t-50___KD3Xm {
  padding-top: 50px !important;
}

.VisitSections-module__p-l-20___UjE35 {
  padding-left: 20px !important;
}

.VisitSections-module__p-l-30___hgqeh {
  padding-left: 30px !important;
}

.VisitSections-module__p-l-40___ZajKM {
  padding-left: 40px !important;
}

.VisitSections-module__p-r-16___HFm0x {
  padding-right: 16px !important;
}

.VisitSections-module__p-r-20___xw3iG {
  padding-right: 20px !important;
}

.VisitSections-module__p-r-30___GZXgU {
  padding-right: 30px !important;
}

.VisitSections-module__p-r-50___OyXmf {
  padding-right: 50px !important;
}

.VisitSections-module__p-r-60____Icms {
  padding-right: 60px !important;
}

.VisitSections-module__m-b-1___NfcUU {
  margin-bottom: 1px !important;
}

.VisitSections-module__m-b-2___BVdZO {
  margin-bottom: 2px !important;
}

.VisitSections-module__m-b-6___raHTd {
  margin-bottom: 6px !important;
}

.VisitSections-module__m-b-8___o7EAf {
  margin-bottom: 8px !important;
}

.VisitSections-module__m-b-10___TOjQp {
  margin-bottom: 10px !important;
}

.VisitSections-module__m-b-14___qHvEG {
  margin-bottom: 14px !important;
}

.VisitSections-module__m-b-16___lsrK0 {
  margin-bottom: 16px !important;
}

.VisitSections-module__m-b-20___Hydve {
  margin-bottom: 20px !important;
}

.VisitSections-module__m-b-22___R5WLu {
  margin-bottom: 22px !important;
}

.VisitSections-module__m-b-24___dNvHS {
  margin-bottom: 24px !important;
}

.VisitSections-module__m-b-30___A0RFB {
  margin-bottom: 30px !important;
}

.VisitSections-module__m-b-32___F9KoA {
  margin-bottom: 32px !important;
}

.VisitSections-module__m-b-40___FjVPi {
  margin-bottom: 40px !important;
}

.VisitSections-module__m-t-2___StBIM {
  margin-top: 2px !important;
}

.VisitSections-module__m-t-3___OKzMo {
  margin-top: 3px !important;
}

.VisitSections-module__m-t-4___vZ1Z0 {
  margin-top: 4px !important;
}

.VisitSections-module__m-t-5___ZcaMK {
  margin-top: 5px !important;
}

.VisitSections-module__m-t-8___uhSqm {
  margin-top: 8px !important;
}

.VisitSections-module__m-t-10___EdyWX {
  margin-top: 10px !important;
}

.VisitSections-module__m-t-15___XDOXv {
  margin-top: 15px !important;
}

.VisitSections-module__m-t-16___Iwu5Y {
  margin-top: 16px !important;
}

.VisitSections-module__m-t-20___vWInV {
  margin-top: 20px !important;
}

.VisitSections-module__m-t-22___qIwRJ {
  margin-top: 22px !important;
}

.VisitSections-module__m-t-30___Njawg {
  margin-top: 30px !important;
}

.VisitSections-module__m-t-32___Ij2Tc {
  margin-top: 32px !important;
}

.VisitSections-module__m-l-auto___wJT7G {
  margin-left: auto !important;
}

.VisitSections-module__m-l-4___ogJ2w {
  margin-left: 4px !important;
}

.VisitSections-module__m-l-5___l2xSP {
  margin-left: 5px !important;
}

.VisitSections-module__m-l-6___ASw0m {
  margin-left: 6px !important;
}

.VisitSections-module__m-l-8___mO2yT {
  margin-left: 8px !important;
}

.VisitSections-module__m-l-10___hyUAJ {
  margin-left: 10px !important;
}

.VisitSections-module__m-l-16___S_ENN {
  margin-left: 16px !important;
}

.VisitSections-module__m-l-20___QhIVz {
  margin-left: 20px !important;
}

.VisitSections-module__m-l-24___UEZ3R {
  margin-left: 24px !important;
}

.VisitSections-module__m-l-30___OUaBk {
  margin-left: 30px !important;
}

.VisitSections-module__m-l-35___hcMOM {
  margin-left: 35px !important;
}

.VisitSections-module__m-l-40___rD5q9 {
  margin-left: 40px !important;
}

.VisitSections-module__m-r-8___BX5U9 {
  margin-right: 8px !important;
}

.VisitSections-module__m-r-10___PcpQn {
  margin-right: 10px !important;
}

.VisitSections-module__m-r-16___voIZu {
  margin-right: 16px !important;
}

.VisitSections-module__m-r-20___eIotA {
  margin-right: 20px !important;
}

.VisitSections-module__m-r-24___mzKTq {
  margin-right: 24px !important;
}

.VisitSections-module__m-r-30___oCgby {
  margin-right: 30px !important;
}

.VisitSections-module__m-r-40___Rcp0K {
  margin-right: 40px !important;
}

.VisitSections-module__border-r-3___srSBo {
  border-radius: 3px !important;
}

.VisitSections-module__border-r-4___cuBnO {
  border-radius: 4px !important;
}

.VisitSections-module__border-r-6___AlzWi {
  border-radius: 6px !important;
}

.VisitSections-module__border-r-10___Kq_Yw {
  border-radius: 10px !important;
}

.VisitSections-module__border-r-12___72309 {
  border-radius: 12px !important;
}

.VisitSections-module__border-r-16___grYqL {
  border-radius: 16px !important;
}

.VisitSections-module__border-r-50___FnrzV {
  border-radius: 50% !important;
}

.VisitSections-module__primary-border___wSdD4 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitSections-module__primary-border-b___rce0V {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitSections-module__primary-border-t___SGWm1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitSections-module__primary-border-l___ZXnBF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitSections-module__primary-border-r____RT1M {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitSections-module__secondary-border___zfFg1 {
  border: 1px solid #637768;
}

.VisitSections-module__secondary-border-b___JZKK5 {
  border-bottom: 1px solid #637768;
}

.VisitSections-module__secondary-border-t___xQmER {
  border-top: 1px solid #637768;
}

.VisitSections-module__secondary-border-l___D4eAq {
  border-left: 1px solid #637768;
}

.VisitSections-module__secondary-border-r___UTJEx {
  border-right: 1px solid #637768;
}

.VisitSections-module__gap-0___Fo55S {
  gap: 0 !important;
}

.VisitSections-module__gap-2___XbGJC {
  gap: 2px !important;
}

.VisitSections-module__gap-4___wAb6Y {
  gap: 4px !important;
}

.VisitSections-module__gap-5___oC7Qo {
  gap: 5px !important;
}

.VisitSections-module__gap-6___kbgCE {
  gap: 6px !important;
}

.VisitSections-module__gap-8___FNT56 {
  gap: 8px !important;
}

.VisitSections-module__gap-10___a9ITG {
  gap: 10px !important;
}

.VisitSections-module__gap-12___Ja8LV {
  gap: 12px !important;
}

.VisitSections-module__gap-14___vYQIs {
  gap: 14px !important;
}

.VisitSections-module__gap-16___Rzi35 {
  gap: 16px !important;
}

.VisitSections-module__gap-18___Cf_Ew {
  gap: 18px !important;
}

.VisitSections-module__gap-20___iNHE5 {
  gap: 20px !important;
}

.VisitSections-module__gap-24___LnoFA {
  gap: 24px !important;
}

.VisitSections-module__gap-26___SMqj_ {
  gap: 26px !important;
}

.VisitSections-module__gap-30___Fvy4v {
  gap: 30px !important;
}

.VisitSections-module__gap-32___utSr8 {
  gap: 32px !important;
}

.VisitSections-module__gap-40___mtT5A {
  gap: 40px !important;
}

.VisitSections-module__gap-50___WxYbi {
  gap: 50px !important;
}

.VisitSections-module__flex-1___GHZmv {
  flex: 1;
}

.VisitSections-module__flex-none___d2awe {
  flex: none !important;
}

.VisitSections-module__flex-column___S5uRG {
  display: flex;
  flex-direction: column !important;
}

.VisitSections-module__flex-row___OX2eo {
  display: flex;
  flex-direction: row !important;
}

.VisitSections-module__vertically-centered____DOY2 {
  display: flex;
  align-items: center !important;
}

.VisitSections-module__horizontally-centered___KywWX {
  display: flex;
  justify-content: center !important;
}

.VisitSections-module__horizontally-end___T6eMO {
  display: flex;
  justify-content: end !important;
}

.VisitSections-module__vertically-start___peX25 {
  display: flex;
  align-items: start !important;
}

.VisitSections-module__space-between___OXu6_ {
  display: flex;
  justify-content: space-between !important;
}

.VisitSections-module__flex-wrap___b445m {
  flex-wrap: wrap !important;
}

.VisitSections-module__height-100___YaGrJ {
  height: 100%;
}

.VisitSections-module__width-50___Zs5AR {
  width: 50% !important;
}

.VisitSections-module__width-100___HB0L1 {
  width: 100%;
}

.VisitSections-module__cursor-pointer___ZDbj6 {
  cursor: pointer;
}

.VisitSections-module__cursor-not-allowed___SmdBT {
  cursor: not-allowed !important;
}

.VisitSections-module__absolute-centered___ICG9w {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.VisitSections-module__absolute___nhBd0 {
  position: absolute;
}

.VisitSections-module__relative___mJRBc {
  position: relative;
}

.VisitSections-module__fixed___qsDXf {
  position: fixed;
}

.VisitSections-module__visible___tmRY4 {
  opacity: 1;
}

.VisitSections-module__invisible___y6nO2 {
  opacity: 0;
}

.VisitSections-module__col-90___DI2Tw {
  width: 90% !important;
}

.VisitSections-module__col-auto___V5nlH {
  width: auto !important;
}

.VisitSections-module__medical-tabs___Koy9t {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.VisitSections-module__medical-table-new___cVkmJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VisitSections-module__medical-table-new___cVkmJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VisitSections-module__medical-table-new___cVkmJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VisitSections-module__medical-table-new___cVkmJ::-webkit-scrollbar-track {
  display: none;
}
.VisitSections-module__medical-table-new___cVkmJ.VisitSections-module__no-pagination___nWGH9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VisitSections-module__medical-table-new___cVkmJ.VisitSections-module__no-pagination___nWGH9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VisitSections-module__medical-table-new___cVkmJ.VisitSections-module__no-pagination___nWGH9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VisitSections-module__medical-table-new___cVkmJ.VisitSections-module__no-pagination___nWGH9::-webkit-scrollbar-track {
  display: none;
}

.VisitSections-module__medical-table-empty___UgMN6 {
  padding: 14px 40px !important;
}

.VisitSections-module__icon-btn___vJeqF {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.VisitSections-module__search-icon___OgZtW {
  width: 24px;
  height: 24px;
  align-self: center;
}

.VisitSections-module__disable-select___vot33 {
  user-select: none;
}

.VisitSections-module__break-word___yt3Jw {
  word-break: break-word;
}

.VisitSections-module__popup-clear-btn___h4nrg {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.VisitSections-module__scroll-m-b-20___cF96C {
  scroll-margin-bottom: 20px;
}

.VisitSections-module__box___E5O2p {
  container-type: inline-size;
  border-top: 1px solid #f4f4f5;
}

.VisitSections-module__grid___lbA1A {
  display: grid;
  padding: 13px 20px;
}
.VisitSections-module__grid___lbA1A > * + * {
  border-top: 1px solid #e4e4e7;
}

.VisitSections-module__section___CjOWb {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 13px 0;
}
.VisitSections-module__section___CjOWb:first-child {
  padding-top: 0;
}
.VisitSections-module__section___CjOWb:last-child {
  padding-bottom: 0;
}

.VisitSections-module__factValue___No6x2 {
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.VisitSections-module__briefBox___xalza {
  border-top: 0;
}

.VisitSections-module__briefGrid___uu6VH {
  padding: 16px 20px;
}

.VisitSections-module__briefSection___AmYPR {
  padding: 16px 0;
}

.VisitSections-module__factRows___QANw4 {
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  margin: 0;
}

.VisitSections-module__factRow___c0CYF {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  align-items: baseline;
  column-gap: 12px;
  padding: 8px 0;
}
.VisitSections-module__factRow___c0CYF:first-child {
  padding-top: 2px;
}
.VisitSections-module__factRow___c0CYF:last-child {
  padding-bottom: 0;
}
.VisitSections-module__factRow___c0CYF + .VisitSections-module__factRow___c0CYF {
  border-top: 1px solid #f4f4f5;
}

.VisitSections-module__factRowValue___TF38W {
  min-width: 0;
  margin: 0;
  font-size: 14px;
  line-height: 1.4286;
  color: #27272a;
}

@container (max-width: 671px) {
  .VisitSections-module__fact___ScJ1H {
    display: grid;
    grid-template-columns: 80px minmax(0, 1fr);
    align-items: baseline;
    column-gap: 13px;
    padding: 6px 0;
  }
}
@container (min-width: 672px) {
  .VisitSections-module__grid___lbA1A.VisitSections-module__briefGrid___uu6VH {
    grid-template-columns: auto minmax(0, 1.2fr) minmax(0, 1fr);
  }
  .VisitSections-module__section___CjOWb.VisitSections-module__briefSection___AmYPR {
    padding: 0 24px;
  }
  .VisitSections-module__section___CjOWb.VisitSections-module__briefSection___AmYPR:first-child {
    padding-left: 0;
  }
  .VisitSections-module__section___CjOWb.VisitSections-module__briefSection___AmYPR:last-child {
    padding-right: 0;
  }
  .VisitSections-module__grid___lbA1A {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.3fr);
  }
  .VisitSections-module__grid___lbA1A > * + * {
    border-top: 0;
    border-left: 1px solid #e4e4e7;
  }
  .VisitSections-module__section___CjOWb {
    padding: 0 20px;
  }
  .VisitSections-module__section___CjOWb:first-child {
    padding-left: 0;
  }
  .VisitSections-module__section___CjOWb:last-child {
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/VisitSections.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,2BAAA;EACA,6BAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,6BAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AA6pBF;AA3pBE;EACE,cAAA;AA6pBJ;AA1pBE;EACE,iBAAA;AA4pBJ;;AAxpBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AA2pBF;;AAxpBA;EACE,aAAA;AA2pBF;;AAxpBA;EACE,kBAAA;AA2pBF;;AAxpBA;EACE,eAAA;AA2pBF;;AAxpBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;AA2pBF;;AAxpBA;EACE,aAAA;EACA,0CAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;AA2pBF;AAzpBE;EACE,gBAAA;AA2pBJ;AAxpBE;EACE,iBAAA;AA0pBJ;AAvpBE;EACE,6BAAA;AAypBJ;;AArpBA;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE;IACE,aAAA;IACA,0CAAA;IACA,qBAAA;IACA,gBAAA;IACA,cAAA;EAwpBF;AACF;AArpBA;EACE;IACE,2DAAA;EAupBF;EAppBA;IACE,eAAA;EAspBF;EAppBE;IACE,eAAA;EAspBJ;EAnpBE;IACE,gBAAA;EAqpBJ;EAjpBA;IACE,qEAAA;EAmpBF;EAjpBE;IACE,aAAA;IACA,8BAAA;EAmpBJ;EA/oBA;IACE,eAAA;EAipBF;EA/oBE;IACE,eAAA;EAipBJ;EA9oBE;IACE,gBAAA;EAgpBJ;AACF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.box {\n  container-type: inline-size;\n  border-top: 1px solid $rule;\n}\n\n.grid {\n  display: grid;\n  padding: 13px 20px;\n\n  > * + * {\n    border-top: 1px solid $hairline;\n  }\n}\n\n.section {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 13px 0;\n\n  &:first-child {\n    padding-top: 0;\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n}\n\n.factValue {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.briefBox {\n  border-top: 0;\n}\n\n.briefGrid {\n  padding: 16px 20px;\n}\n\n.briefSection {\n  padding: 16px 0;\n}\n\n.factRows {\n  display: flex;\n  width: 100%;\n  min-width: 0;\n  flex-direction: column;\n  margin: 0;\n}\n\n.factRow {\n  display: grid;\n  grid-template-columns: 88px minmax(0, 1fr);\n  align-items: baseline;\n  column-gap: 12px;\n  padding: 8px 0;\n\n  &:first-child {\n    padding-top: 2px;\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  & + & {\n    border-top: 1px solid $rule;\n  }\n}\n\n.factRowValue {\n  min-width: 0;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #27272a;\n}\n\n@container (max-width: 671px) {\n  .fact {\n    display: grid;\n    grid-template-columns: 80px minmax(0, 1fr);\n    align-items: baseline;\n    column-gap: 13px;\n    padding: 6px 0;\n  }\n}\n\n@container (min-width: 672px) {\n  .grid.briefGrid {\n    grid-template-columns: auto minmax(0, 1.2fr) minmax(0, 1fr);\n  }\n\n  .section.briefSection {\n    padding: 0 24px;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n\n  .grid {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.3fr);\n\n    > * + * {\n      border-top: 0;\n      border-left: 1px solid $hairline;\n    }\n  }\n\n  .section {\n    padding: 0 20px;\n\n    &:first-child {\n      padding-left: 0;\n    }\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `VisitSections-module__font-s-10___Ofuik`,
	"fontS12": `VisitSections-module__font-s-12___MhnRP`,
	"fontS13": `VisitSections-module__font-s-13___sECge`,
	"fontS14": `VisitSections-module__font-s-14___F1GeS`,
	"fontS15": `VisitSections-module__font-s-15___bZ0Mr`,
	"fontS16": `VisitSections-module__font-s-16___zLvT3`,
	"fontS18": `VisitSections-module__font-s-18___tXxVk`,
	"fontS20": `VisitSections-module__font-s-20___t3MH9`,
	"fontS22": `VisitSections-module__font-s-22___H6R9O`,
	"fontS28": `VisitSections-module__font-s-28___amOfC`,
	"fontW400": `VisitSections-module__font-w-400___BPfgV`,
	"fontW500": `VisitSections-module__font-w-500___AbNt6`,
	"fontW600": `VisitSections-module__font-w-600___pV0wu`,
	"fontW700": `VisitSections-module__font-w-700___bEv_W`,
	"p5": `VisitSections-module__p-5___aLTR7`,
	"p12": `VisitSections-module__p-12___pwgjq`,
	"p16": `VisitSections-module__p-16___Gh9Eg`,
	"p30": `VisitSections-module__p-30___Mmkrr`,
	"pB0": `VisitSections-module__p-b-0___XO5_G`,
	"pB5": `VisitSections-module__p-b-5___AbwPu`,
	"pB10": `VisitSections-module__p-b-10___poEyW`,
	"pB12": `VisitSections-module__p-b-12___bx6P_`,
	"pB16": `VisitSections-module__p-b-16___CzPrB`,
	"pB18": `VisitSections-module__p-b-18___W8ufW`,
	"pB20": `VisitSections-module__p-b-20___WYjdJ`,
	"pB25": `VisitSections-module__p-b-25___kBrIu`,
	"pB30": `VisitSections-module__p-b-30___vm5E7`,
	"pB50": `VisitSections-module__p-b-50___P1PlP`,
	"pT0": `VisitSections-module__p-t-0___ZBW1e`,
	"pT12": `VisitSections-module__p-t-12___rauqN`,
	"pT16": `VisitSections-module__p-t-16___gLLa2`,
	"pT18": `VisitSections-module__p-t-18___fQpHS`,
	"pT20": `VisitSections-module__p-t-20___ifiMw`,
	"pT30": `VisitSections-module__p-t-30___AU4N8`,
	"pT40": `VisitSections-module__p-t-40___fbo7J`,
	"pT50": `VisitSections-module__p-t-50___KD3Xm`,
	"pL20": `VisitSections-module__p-l-20___UjE35`,
	"pL30": `VisitSections-module__p-l-30___hgqeh`,
	"pL40": `VisitSections-module__p-l-40___ZajKM`,
	"pR16": `VisitSections-module__p-r-16___HFm0x`,
	"pR20": `VisitSections-module__p-r-20___xw3iG`,
	"pR30": `VisitSections-module__p-r-30___GZXgU`,
	"pR50": `VisitSections-module__p-r-50___OyXmf`,
	"pR60": `VisitSections-module__p-r-60____Icms`,
	"mB1": `VisitSections-module__m-b-1___NfcUU`,
	"mB2": `VisitSections-module__m-b-2___BVdZO`,
	"mB6": `VisitSections-module__m-b-6___raHTd`,
	"mB8": `VisitSections-module__m-b-8___o7EAf`,
	"mB10": `VisitSections-module__m-b-10___TOjQp`,
	"mB14": `VisitSections-module__m-b-14___qHvEG`,
	"mB16": `VisitSections-module__m-b-16___lsrK0`,
	"mB20": `VisitSections-module__m-b-20___Hydve`,
	"mB22": `VisitSections-module__m-b-22___R5WLu`,
	"mB24": `VisitSections-module__m-b-24___dNvHS`,
	"mB30": `VisitSections-module__m-b-30___A0RFB`,
	"mB32": `VisitSections-module__m-b-32___F9KoA`,
	"mB40": `VisitSections-module__m-b-40___FjVPi`,
	"mT2": `VisitSections-module__m-t-2___StBIM`,
	"mT3": `VisitSections-module__m-t-3___OKzMo`,
	"mT4": `VisitSections-module__m-t-4___vZ1Z0`,
	"mT5": `VisitSections-module__m-t-5___ZcaMK`,
	"mT8": `VisitSections-module__m-t-8___uhSqm`,
	"mT10": `VisitSections-module__m-t-10___EdyWX`,
	"mT15": `VisitSections-module__m-t-15___XDOXv`,
	"mT16": `VisitSections-module__m-t-16___Iwu5Y`,
	"mT20": `VisitSections-module__m-t-20___vWInV`,
	"mT22": `VisitSections-module__m-t-22___qIwRJ`,
	"mT30": `VisitSections-module__m-t-30___Njawg`,
	"mT32": `VisitSections-module__m-t-32___Ij2Tc`,
	"mLAuto": `VisitSections-module__m-l-auto___wJT7G`,
	"mL4": `VisitSections-module__m-l-4___ogJ2w`,
	"mL5": `VisitSections-module__m-l-5___l2xSP`,
	"mL6": `VisitSections-module__m-l-6___ASw0m`,
	"mL8": `VisitSections-module__m-l-8___mO2yT`,
	"mL10": `VisitSections-module__m-l-10___hyUAJ`,
	"mL16": `VisitSections-module__m-l-16___S_ENN`,
	"mL20": `VisitSections-module__m-l-20___QhIVz`,
	"mL24": `VisitSections-module__m-l-24___UEZ3R`,
	"mL30": `VisitSections-module__m-l-30___OUaBk`,
	"mL35": `VisitSections-module__m-l-35___hcMOM`,
	"mL40": `VisitSections-module__m-l-40___rD5q9`,
	"mR8": `VisitSections-module__m-r-8___BX5U9`,
	"mR10": `VisitSections-module__m-r-10___PcpQn`,
	"mR16": `VisitSections-module__m-r-16___voIZu`,
	"mR20": `VisitSections-module__m-r-20___eIotA`,
	"mR24": `VisitSections-module__m-r-24___mzKTq`,
	"mR30": `VisitSections-module__m-r-30___oCgby`,
	"mR40": `VisitSections-module__m-r-40___Rcp0K`,
	"borderR3": `VisitSections-module__border-r-3___srSBo`,
	"borderR4": `VisitSections-module__border-r-4___cuBnO`,
	"borderR6": `VisitSections-module__border-r-6___AlzWi`,
	"borderR10": `VisitSections-module__border-r-10___Kq_Yw`,
	"borderR12": `VisitSections-module__border-r-12___72309`,
	"borderR16": `VisitSections-module__border-r-16___grYqL`,
	"borderR50": `VisitSections-module__border-r-50___FnrzV`,
	"primaryBorder": `VisitSections-module__primary-border___wSdD4`,
	"primaryBorderB": `VisitSections-module__primary-border-b___rce0V`,
	"primaryBorderT": `VisitSections-module__primary-border-t___SGWm1`,
	"primaryBorderL": `VisitSections-module__primary-border-l___ZXnBF`,
	"primaryBorderR": `VisitSections-module__primary-border-r____RT1M`,
	"secondaryBorder": `VisitSections-module__secondary-border___zfFg1`,
	"secondaryBorderB": `VisitSections-module__secondary-border-b___JZKK5`,
	"secondaryBorderT": `VisitSections-module__secondary-border-t___xQmER`,
	"secondaryBorderL": `VisitSections-module__secondary-border-l___D4eAq`,
	"secondaryBorderR": `VisitSections-module__secondary-border-r___UTJEx`,
	"gap0": `VisitSections-module__gap-0___Fo55S`,
	"gap2": `VisitSections-module__gap-2___XbGJC`,
	"gap4": `VisitSections-module__gap-4___wAb6Y`,
	"gap5": `VisitSections-module__gap-5___oC7Qo`,
	"gap6": `VisitSections-module__gap-6___kbgCE`,
	"gap8": `VisitSections-module__gap-8___FNT56`,
	"gap10": `VisitSections-module__gap-10___a9ITG`,
	"gap12": `VisitSections-module__gap-12___Ja8LV`,
	"gap14": `VisitSections-module__gap-14___vYQIs`,
	"gap16": `VisitSections-module__gap-16___Rzi35`,
	"gap18": `VisitSections-module__gap-18___Cf_Ew`,
	"gap20": `VisitSections-module__gap-20___iNHE5`,
	"gap24": `VisitSections-module__gap-24___LnoFA`,
	"gap26": `VisitSections-module__gap-26___SMqj_`,
	"gap30": `VisitSections-module__gap-30___Fvy4v`,
	"gap32": `VisitSections-module__gap-32___utSr8`,
	"gap40": `VisitSections-module__gap-40___mtT5A`,
	"gap50": `VisitSections-module__gap-50___WxYbi`,
	"flex1": `VisitSections-module__flex-1___GHZmv`,
	"flexNone": `VisitSections-module__flex-none___d2awe`,
	"flexColumn": `VisitSections-module__flex-column___S5uRG`,
	"flexRow": `VisitSections-module__flex-row___OX2eo`,
	"verticallyCentered": `VisitSections-module__vertically-centered____DOY2`,
	"horizontallyCentered": `VisitSections-module__horizontally-centered___KywWX`,
	"horizontallyEnd": `VisitSections-module__horizontally-end___T6eMO`,
	"verticallyStart": `VisitSections-module__vertically-start___peX25`,
	"spaceBetween": `VisitSections-module__space-between___OXu6_`,
	"flexWrap": `VisitSections-module__flex-wrap___b445m`,
	"height100": `VisitSections-module__height-100___YaGrJ`,
	"width50": `VisitSections-module__width-50___Zs5AR`,
	"width100": `VisitSections-module__width-100___HB0L1`,
	"cursorPointer": `VisitSections-module__cursor-pointer___ZDbj6`,
	"cursorNotAllowed": `VisitSections-module__cursor-not-allowed___SmdBT`,
	"absoluteCentered": `VisitSections-module__absolute-centered___ICG9w`,
	"absolute": `VisitSections-module__absolute___nhBd0`,
	"relative": `VisitSections-module__relative___mJRBc`,
	"fixed": `VisitSections-module__fixed___qsDXf`,
	"visible": `VisitSections-module__visible___tmRY4`,
	"invisible": `VisitSections-module__invisible___y6nO2`,
	"col90": `VisitSections-module__col-90___DI2Tw`,
	"colAuto": `VisitSections-module__col-auto___V5nlH`,
	"medicalTabs": `VisitSections-module__medical-tabs___Koy9t`,
	"medicalTableNew": `VisitSections-module__medical-table-new___cVkmJ`,
	"noPagination": `VisitSections-module__no-pagination___nWGH9`,
	"medicalTableEmpty": `VisitSections-module__medical-table-empty___UgMN6`,
	"iconBtn": `VisitSections-module__icon-btn___vJeqF`,
	"searchIcon": `VisitSections-module__search-icon___OgZtW`,
	"disableSelect": `VisitSections-module__disable-select___vot33`,
	"breakWord": `VisitSections-module__break-word___yt3Jw`,
	"popupClearBtn": `VisitSections-module__popup-clear-btn___h4nrg`,
	"scrollMB20": `VisitSections-module__scroll-m-b-20___cF96C`,
	"box": `VisitSections-module__box___E5O2p`,
	"grid": `VisitSections-module__grid___lbA1A`,
	"section": `VisitSections-module__section___CjOWb`,
	"factValue": `VisitSections-module__factValue___No6x2`,
	"briefBox": `VisitSections-module__briefBox___xalza`,
	"briefGrid": `VisitSections-module__briefGrid___uu6VH`,
	"briefSection": `VisitSections-module__briefSection___AmYPR`,
	"factRows": `VisitSections-module__factRows___QANw4`,
	"factRow": `VisitSections-module__factRow___c0CYF`,
	"factRowValue": `VisitSections-module__factRowValue___TF38W`,
	"fact": `VisitSections-module__fact___ScJ1H`
};
module.exports = ___CSS_LOADER_EXPORT___;
